<template lang="pug">
.widget-container.pointer(@click="launchWbet")
  //- .faq
  //-   .title-wrap
  //-     span.title-text HOT MATCH
  iframe.wbet-widget.pe-none(:src="widgetUrl")
</template>
<script>
import config from '@/config'
export default{
  data(){
    return{

    }
  },
  computed:{
    widgetUrl(){
      return config.wbetWidget
    },
    isLoggedIn(){
			return this.$store.getters.isLoggedIn
		},
  },
  methods:{
    launchWbet(){
      if(this.isLoggedIn){
        // this.$router.push("/launchWbet").catch(err => {});
        window.open(this.$router.resolve("/launchWbet").href, "_blank", "noopener,noreferrer");
      }else{
        this.$router.push("/login").catch(err => {});
      }
      
    }
  }
}
</script>
<style lang="scss" scoped>
.widget-container{
  background: url(/new/img/home/stadium-bg.png) no-repeat center;
  background-size: cover;
}
.wbet-widget{
  // background: #8470ff;
  // background: url("/new/img/home/stadium-bg.png");
  width: 100%;
  height: 400px;
  @media (max-width: 767px) {
    height: 330px;
  }
}
</style>